<template>
    <nav aria-label="Breadcrumb">
        <ol
            role="list"
            class="flex flex-wrap p-2"
            v-if="breadcrumbs.length"
        >
            <template v-for="(crumb, index) in breadcrumbs">
                <li
                    :key="index"
                    class="flex items-center"
                    v-if="index !== breadcrumbs.length - 1"
                >
                    <router-link
                        class="breadcrumb-item"
                        :to="crumb.to"
                    >
                        {{ $t(crumb.label) }}
                    </router-link>
                    <span class="mx-2 text-gray-500">></span>
                </li>
                <li
                    :key="index+'end'"
                    class="flex items-center"
                    v-else
                >
                    <span class="text-gray-500">{{ crumb.label }}</span>
                </li>
            </template>

        </ol>
    </nav>
</template>

<script>


export default {
    name: "breadcrumbs",
    data() {
        return {
            breadcrumbs: []
        };
    },
    mounted() {
        this.breadcrumbs = [];
        if (!this.$route.matched) {
            return;
        }
        let crumbs = this.$route.matched
            .filter((route) => {
                return route.meta.breadcrumb !== null;
            });

        crumbs.forEach((route) => {
                let crumb = route.meta.breadcrumb;
                if (crumb instanceof Function) {
                    crumb = crumb.call(this);
                }
                let label =crumb?.label ?? route.name;
                let parent = crumb?.parent ?? null;

                if (parent) {
                    let parentRoute = this.$router.resolve({name:parent});
                    if (parentRoute) {
                        this.breadcrumbs.push({
                            label: this.$t(parentRoute.meta.title),
                            to: {
                                name: parentRoute.name,
                            }
                        });
                    }
                }

                this.breadcrumbs.push({
                    label: this.$t(label),
                    to: {
                        name: route.name,
                        params: route.params,
                        query: route.query
                    }
                });
            });
    }
};
</script>
